module.exports = __webpack_public_path__ + "static/media/UnitedSansReg-Light.2144de57.ttf";